import {
  SectionsRouteContainer,
  RouteButton,
  Separator,
} from '@styled_components/helpCentre/styled.components'
import ArrowDividerIcon from '@public/static/icons/arrowDividerIcon'
import { useTranslation } from 'react-i18next'

type Category = 'student' | 'author' | 'referralPartner' | 'legal'

interface RouteNavBarProps {
  currentCategory: Category
  currentArticle?: string
  setCategory(category: Category): any
}

const RouteNavBar = ({
  currentCategory,
  currentArticle,
  setCategory,
}: RouteNavBarProps) => {
  const { t } = useTranslation('helpCentre')

  const CategoryTitles = {
    student: t('student'),
    author: t('author'),
    referralPartner: t('referralPartner'),
    legal: t('legal'),
  }

  return (
    <SectionsRouteContainer>
      <RouteButton
        onClick={() => {
          setCategory('student')
        }}
      >
        {t('allTopics')}
      </RouteButton>
      <Separator>
        <ArrowDividerIcon />
      </Separator>
      <RouteButton
        $active={currentArticle ? false : true}
        onClick={() => {
          setCategory(currentCategory)
        }}
      >
        {CategoryTitles[`${currentCategory}`]}
      </RouteButton>
      {currentArticle && (
        <Separator>
          <ArrowDividerIcon />
        </Separator>
      )}
      {currentArticle && (
        <RouteButton $active={true}>{t(currentArticle)}</RouteButton>
      )}
    </SectionsRouteContainer>
  )
}

export default RouteNavBar
